const switcher = () => {
  const init = () => {
    languages();
  };

  const languages = () => {
    const el = {
      switcherEl: document.querySelectorAll(
        ".mi-SwitcherLanguage .elementor-icon-list-item"
      ),
    };

    if (el.switcherEl.length === 0) return;

    for (let i = 0; i < el.switcherEl.length; i++) {
      el.switcherEl[i].onclick = function () {
        var c = 0;
        while (c < el.switcherEl.length) {
          el.switcherEl[c++].className = "elementor-icon-list-item";
        }
        el.switcherEl[i].className = "elementor-icon-list-item active";
      };
    }
  };

  init();
};

switcher();
